module.exports = __webpack_public_path__ + "static/media/picture rmu.3e598c8e.jpg";